import { Icon, IconProps } from "../";

export const SearchIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.875 3C8.78642 3 6.78338 3.82969 5.30653 5.30653C3.82969 6.78338 3 8.78642 3 10.875C3 12.9636 3.82969 14.9666 5.30653 16.4435C6.78338 17.9203 8.78642 18.75 10.875 18.75C12.7121 18.75 14.483 18.1081 15.8878 16.9485L18.9697 20.0303C19.2626 20.3232 19.7374 20.3232 20.0303 20.0303C20.3232 19.7374 20.3232 19.2626 20.0303 18.9697L16.9485 15.8878C18.1081 14.483 18.75 12.7121 18.75 10.875C18.75 8.78642 17.9203 6.78338 16.4435 5.30653C14.9666 3.82969 12.9636 3 10.875 3ZM6.36719 6.36719C7.56274 5.17165 9.18425 4.5 10.875 4.5C12.5658 4.5 14.1873 5.17165 15.3828 6.36719C16.5784 7.56274 17.25 9.18425 17.25 10.875C17.25 12.5658 16.5784 14.1873 15.3828 15.3828C14.1873 16.5784 12.5658 17.25 10.875 17.25C9.18425 17.25 7.56274 16.5784 6.36719 15.3828C5.17165 14.1873 4.5 12.5658 4.5 10.875C4.5 9.18425 5.17165 7.56274 6.36719 6.36719Z"
      />
    </Icon>
  );
};
